export default __webpack_public_path__ + "static/media/ActiveHeaderQuestion.2a4d7309.svg";